export enum ChangelogChangeType{
    bugfix = 0,
    feature = 1,
    improvement = 2
}

export type APISchemaChange = {
    type: ChangelogChangeType,
    description: string,
    releaseId?: string,
    id?: string
  };

export type APISchemaRelease = {
    id: string,
    version: string,
    releaseDate: string,
    changes: APISchemaChange[];
  };

  export type ApiSchemaReleasePagedResponseData = {
    totalRelease: number;
    pageIndex: number;
    pageSize: number;
    count: number;
    releaseResponse: APISchemaRelease[];
  };